import has from 'lodash/has';
export function generateUniqueId() {
    return String(Date.now().toString(36) + Math.random().toString(36).substr(2));
}
/* eslint-disable */
export function isObject(value) {
    return value !== null && typeof value === 'object';
}
export function getLocationId() {
    const params = new URLSearchParams(window.location.search);
    return params.get('location-id');
}
export function getWindowSrc() {
    const location = window.location;
    const urlObject = new URL(location.pathname, location.origin);
    return urlObject.toString();
}
export function hasType(type, obj) {
    return isObject(obj) && obj.__type__ && obj.__type__ === type;
}
export function hasOwnProperty(obj, path) {
    return has(obj, path);
}
export function traverseObject(traversableObject, processor) {
    for (let index in traversableObject) {
        const currentEntry = traversableObject[index];
        processor.apply(this, [traversableObject, index, currentEntry]);
        if (isObject(currentEntry)) {
            traverseObject(currentEntry, processor);
        }
    }
}
//# sourceMappingURL=utils.js.map